var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9991 11.6424C23.9991 5.36889 18.815 0.28418 12.4199 0.28418C6.02484 0.28418 0.84082 5.36889 0.84082 11.6424C0.84082 17.3102 5.07527 22.0087 10.6106 22.8606V14.925H7.67114V11.6415H10.6106V9.13984C10.6106 6.2927 12.3398 4.72053 14.984 4.72053C16.251 4.72053 17.576 4.94201 17.576 4.94201V7.73709H16.1169C14.679 7.73709 14.2303 8.61262 14.2303 9.51087V11.6424H17.4418L16.9285 14.9259H14.2303V22.8616C19.7656 22.0097 24 17.3112 24 11.6424H23.9991Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0204916e39a0af9651bf58bf50f4b52b.svg";
export { ForwardRef as ReactComponent };